import React from "react";
import OrbatChart from "components/event/OrbatChart";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";

interface IPreviewProps {
  event: any;
}

/*
  known bug
  preview wrongly fits into blades and overflows when it should shrink
 */

const Preview = ({ event: { sides } }: IPreviewProps) => (
  <Container>
    <Typography variant="h5" component="h3">
      PREVIEW
    </Typography>
    <OrbatChart sides={sides} />
  </Container>
);

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #36393f;
  border-radius: 5px;
  padding: 10px;
  overflow: auto;

  .orgchart-container {
    margin: 0;
  }
`;

export default Preview;
